(() => {
  const B = window.binder || { routes: {}, strings: {} };

  function formatMoney(cents, format) {
    const fmt = format || B.moneyFormat || '${{amount}}';
    const value = Number(cents) || 0;
    const fixed = (n, d, t = ',', dec = '.') => {
      const [whole, frac] = (n / 100).toFixed(d).split('.');
      const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return frac ? withThousands + dec + frac : withThousands;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return fixed(value, 0);
        case 'amount_with_comma_separator':
          return fixed(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return fixed(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return fixed(value, 2, "'", '.');
        default:
          return fixed(value, 2);
      }
    });
  }

  const storage = {
    get(key, fallback) {
      try {
        const raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    },
    remove(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (e) {}
    },
  };

  function navigate(url) {
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        window.location.href = url;
      });
    } else {
      window.location.href = url;
    }
  }

  /* Dialogs */
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
  });

  /* Cart count and toast */
  async function refreshCartCount() {
    try {
      const res = await fetch(`${B.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
      });
    } catch (e) {}
  }

  function showToast(message) {
    const toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('.cart-toast__title').textContent = message;
    if (!toast.open) toast.show();
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.close(), 6000);
  }

  async function addToCart(form) {
    const res = await fetch(B.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    const body = await res.json();
    if (!res.ok) throw new Error(body.description || body.message || B.strings.addError);
    await refreshCartCount();
    showToast(B.strings.added.replace('[title]', body.product_title || body.title || ''));
    return body;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await addToCart(form);
    } catch (err) {
      showToast(err.message || B.strings.addError);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  /* Quantity steppers */
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.closest('[data-qty]')?.querySelector('input');
    if (!input) return;
    const min = Number(input.min || 0);
    const max = input.max ? Number(input.max) : Infinity;
    const next = Math.min(max, Math.max(min, (Number(input.value) || 0) + Number(step.dataset.qtyStep)));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product form */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    const dataEl = section.parentElement.querySelector('[data-product-json]');
    if (!form || !dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-button]');
    const priceEl = section.querySelector('[data-product-price]');
    const stockEl = section.querySelector('[data-product-stock]');
    const errorEl = form.querySelector('[data-form-error]');
    const mainMedia = section.querySelector('[data-main-media] img');
    const optionInputs = form.querySelectorAll('[data-option-input]');

    const buttonLabel = (variant) => {
      if (!variant) return B.strings.unavailable;
      if (!variant.available) return B.strings.soldOut;
      return data.preorder ? B.strings.preorder : B.strings.addToCart;
    };

    const selectedOptions = () => {
      const positions = [...new Set([...optionInputs].map((i) => i.dataset.optionInput))].sort();
      return positions.map((pos) => form.querySelector(`[data-option-input="${pos}"]:checked`)?.value);
    };

    const update = () => {
      const opts = selectedOptions();
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      button.textContent = buttonLabel(variant);
      button.disabled = !variant || !variant.available;
      if (!variant) {
        stockEl.textContent = B.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      const compare = variant.compare_at_price
        ? ` <s class="price-compare">${variant.compare_at_price}</s>`
        : '';
      priceEl.innerHTML = `<span class="price${variant.compare_at_price ? ' price--sale' : ''}">${variant.price}</span>${compare}`;
      if (!variant.available) {
        stockEl.textContent = B.strings.soldOut;
      } else if (variant.inventory !== null && variant.inventory > 0 && variant.inventory <= data.lowStock) {
        stockEl.textContent = (stockEl.dataset.lowTemplate || 'Only [count] left').replace('[count]', variant.inventory);
      } else {
        stockEl.textContent = '';
      }
      if (variant.image && mainMedia) {
        mainMedia.removeAttribute('srcset');
        mainMedia.src = variant.image;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionInputs.forEach((input) => input.addEventListener('change', update));

    section.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainMedia) return;
        const swap = () => {
          mainMedia.src = thumb.dataset.src;
          mainMedia.srcset = thumb.dataset.srcset;
          mainMedia.alt = thumb.dataset.alt;
          section.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-current', t === thumb));
        };
        if (document.startViewTransition) document.startViewTransition(swap);
        else swap();
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      errorEl.hidden = true;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      try {
        await addToCart(form);
      } catch (err) {
        errorEl.textContent = err.message || B.strings.addError;
        errorEl.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    });
  });

  /* Sorting, select navigation and auto-submitting filter forms */
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      navigate(url.toString());
    });
  });

  document.querySelectorAll('[data-navigate-select]').forEach((select) => {
    select.addEventListener('change', () => navigate(select.value));
  });

  document.querySelectorAll('form[data-autosubmit]').forEach((form) => {
    let timer;
    form.addEventListener('change', (event) => {
      if (event.target.type === 'number') return;
      clearTimeout(timer);
      timer = setTimeout(() => form.requestSubmit(), 150);
    });
  });

  const filterPanels = document.querySelectorAll('[data-filters]');
  if (filterPanels.length && window.matchMedia('(max-width: 989px)').matches) {
    filterPanels.forEach((panel) => panel.removeAttribute('open'));
  }

  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-qty-input], [data-cart-qty]')) form.requestSubmit();
    });
  });

  /* Predictive search */
  document.querySelectorAll('[data-predictive-search]').forEach((box) => {
    const input = box.querySelector('input[type="search"]');
    const results = box.querySelector('.predictive');
    if (!input || !results || !B.routes.predictive_search_url) return;
    let controller;
    let timer;
    let active = -1;

    const close = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    };

    const escapeHtml = (s) =>
      String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    const render = (products, query) => {
      if (!products.length) {
        results.innerHTML = `<p class="muted predictive__empty">${escapeHtml(B.strings.searchNoResults)}</p>`;
      } else {
        results.innerHTML =
          products
            .map(
              (p, i) => `
          <a class="predictive__item" id="${input.id}-opt-${i}" role="option" aria-selected="false" href="${escapeHtml(p.url)}">
            ${p.image ? `<img src="${escapeHtml(p.image)}&width=100" alt="" width="40" height="56" loading="lazy">` : '<span></span>'}
            <span>${escapeHtml(p.title)}<span class="predictive__meta">${escapeHtml(p.meta)}</span></span>
            <strong>${escapeHtml(p.price)}</strong>
          </a>`
            )
            .join('') +
          `<a class="predictive__all" href="${B.routes.search_url}?q=${encodeURIComponent(query)}&options%5Bprefix%5D=last">${escapeHtml(
            (B.strings.searchAll || '[terms]').replace('[terms]', query)
          )}</a>`;
      }
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const metaFromTags = (tags) => {
      const list = Array.isArray(tags) ? tags : String(tags || '').split(',');
      const tagCfg = B.tags || { separator: ':', set: 'set', number: 'number' };
      const pick = (name) => {
        const prefix = (name + tagCfg.separator).toLowerCase();
        const t = list.find((x) => x.trim().toLowerCase().startsWith(prefix));
        return t ? t.trim().slice(prefix.length).trim() : '';
      };
      const set = pick(tagCfg.set);
      const num = pick(tagCfg.number);
      return [set, num && '#' + num].filter(Boolean).join(', ');
    };

    const search = async (query) => {
      controller?.abort();
      controller = new AbortController();
      try {
        const url = `${B.routes.predictive_search_url}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.sku,tag`;
        const res = await fetch(url, { signal: controller.signal });
        const json = await res.json();
        const products = (json.resources?.results?.products || []).map((p) => ({
          title: p.title,
          url: p.url,
          image: p.featured_image?.url || p.image || '',
          price: formatMoney(Math.round(Number(p.price) * 100)),
          meta: metaFromTags(p.tags),
        }));
        render(products, query);
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) return close();
      timer = setTimeout(() => search(q), 180);
    });

    input.addEventListener('keydown', (event) => {
      const items = [...results.querySelectorAll('.predictive__item')];
      if (event.key === 'Escape') return close();
      if (!items.length || results.hidden) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        active = (active + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach((el, i) => el.setAttribute('aria-selected', i === active));
        input.setAttribute('aria-activedescendant', items[active].id);
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        navigate(items[active].href);
      }
    });

    document.addEventListener('click', (event) => {
      if (!box.contains(event.target)) close();
    });
  });

  /* Events game filter */
  document.querySelectorAll('[data-events]').forEach((section) => {
    const buttons = section.querySelectorAll('[data-event-filter]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const game = button.dataset.eventFilter;
        buttons.forEach((b) => b.setAttribute('aria-pressed', b === button));
        section.querySelectorAll('[data-event-day]').forEach((day) => {
          let visible = 0;
          day.querySelectorAll('.event-card').forEach((card) => {
            const show = !game || card.dataset.game === game;
            card.hidden = !show;
            if (show) visible += 1;
          });
          day.hidden = visible === 0;
        });
      });
    });
  });

  /* Buylist */
  document.querySelectorAll('[data-buylist]').forEach((root) => {
    const KEY = 'binder:buylist';
    const linesEl = root.querySelector('[data-buylist-lines]');
    const form = root.querySelector('[data-buylist-form]');
    const submit = root.querySelector('[data-buylist-submit]');
    const body = root.querySelector('[data-buylist-body]');
    const filter = root.querySelector('[data-buylist-filter]');
    const noMatch = root.querySelector('[data-buylist-nomatch]');

    if (root.querySelector('[data-buylist-sent]')) storage.remove(KEY);
    let list = storage.get(KEY, []);

    const totals = () =>
      list.reduce(
        (acc, l) => {
          acc.cash += l.cash * l.qty;
          acc.credit += l.credit * l.qty;
          return acc;
        },
        { cash: 0, credit: 0 }
      );

    const escapeHtml = (s) =>
      String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    const render = () => {
      if (!linesEl) return;
      if (!list.length) {
        linesEl.innerHTML = `<li class="muted">${escapeHtml(B.strings.buylistEmpty)}</li>`;
      } else {
        linesEl.innerHTML = list
          .map(
            (l, i) => `
          <li class="buylist-cart__line">
            <span>${escapeHtml(l.title)}<span class="predictive__meta">${escapeHtml(l.condition)}${l.detail ? ', ' + escapeHtml(l.detail) : ''}</span></span>
            <span>&times;${l.qty}</span>
            <button type="button" data-buylist-remove="${i}" aria-label="${escapeHtml(B.strings.buylistRemove)} ${escapeHtml(l.title)}">&times;</button>
          </li>`
          )
          .join('');
      }
      const t = totals();
      root.querySelector('[data-buylist-total="cash"]').textContent = formatMoney(t.cash);
      root.querySelector('[data-buylist-total="credit"]').textContent = formatMoney(t.credit);
      if (submit) submit.disabled = list.length === 0;
      storage.set(KEY, list);
    };

    root.addEventListener('click', (event) => {
      const add = event.target.closest('[data-buylist-add]');
      if (add) {
        const d = add.dataset;
        const existing = list.find((l) => l.id === d.id && l.condition === d.condition);
        if (existing) existing.qty += 1;
        else
          list.push({
            id: d.id,
            title: d.title,
            detail: d.detail,
            condition: d.condition,
            cash: Number(d.cash) || 0,
            credit: Number(d.credit) || 0,
            qty: 1,
          });
        render();
        return;
      }
      const remove = event.target.closest('[data-buylist-remove]');
      if (remove) {
        const i = Number(remove.dataset.buylistRemove);
        if (list[i].qty > 1) list[i].qty -= 1;
        else list.splice(i, 1);
        render();
      }
    });

    form?.addEventListener('submit', () => {
      const t = totals();
      const lines = list.map(
        (l) =>
          `${l.qty} x ${l.title}${l.detail ? ' (' + l.detail + ')' : ''} [${l.condition}] cash ${formatMoney(l.cash)} / credit ${formatMoney(l.credit)} each`
      );
      lines.push('', `Cash total: ${formatMoney(t.cash)}`, `Credit total: ${formatMoney(t.credit)}`);
      if (body) body.value = lines.join('\n');
    });

    filter?.addEventListener('input', () => {
      const q = filter.value.trim().toLowerCase();
      let shown = 0;
      root.querySelectorAll('[data-buylist-row]').forEach((row) => {
        const match = !q || row.dataset.search.includes(q);
        row.hidden = !match;
        if (match) shown += 1;
      });
      if (noMatch) noMatch.hidden = shown > 0;
    });

    render();
  });

  /* Menu drawer and dropdowns */
  document.querySelectorAll('[data-drawer-open]').forEach((button) => {
    const drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer) return;
    button.addEventListener('click', () => {
      drawer.showModal();
      button.setAttribute('aria-expanded', 'true');
    });
    drawer.addEventListener('close', () => button.setAttribute('aria-expanded', 'false'));
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
  });

  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
  const dropdowns = [...document.querySelectorAll('[data-hover-menu]')];
  dropdowns.forEach((menu) => {
    let timer;
    menu.addEventListener('mouseenter', () => {
      if (!hoverCapable.matches) return;
      clearTimeout(timer);
      dropdowns.forEach((other) => other !== menu && other.removeAttribute('open'));
      menu.setAttribute('open', '');
    });
    menu.addEventListener('mouseleave', () => {
      if (!hoverCapable.matches) return;
      timer = setTimeout(() => menu.removeAttribute('open'), 150);
    });
    menu.addEventListener('toggle', () => {
      if (menu.open) dropdowns.forEach((other) => other !== menu && other.removeAttribute('open'));
    });
  });

  const barGroups = () => [...document.querySelectorAll('.filters--bar .filter-group')];
  document.addEventListener('toggle', (event) => {
    const group = event.target;
    if (!(group instanceof HTMLDetailsElement) || !group.open || !group.closest('.filters--bar')) return;
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    barGroups().forEach((other) => other !== group && other.removeAttribute('open'));
  }, true);

  document.addEventListener('click', (event) => {
    dropdowns.forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
    });
    if (window.matchMedia('(min-width: 990px)').matches) {
      barGroups().forEach((group) => {
        if (group.open && !group.contains(event.target)) group.removeAttribute('open');
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    [...dropdowns, ...barGroups()].forEach((d) => {
      if (d.open) {
        d.removeAttribute('open');
        d.querySelector('summary')?.focus();
      }
    });
  });

  /* 3D carousel */
  class Carousel3D {
    constructor(root) {
      this.root = root;
      this.ring = root.querySelector('[data-ring]');
      this.slides = [...root.querySelectorAll('[data-slide]')];
      this.dots = [...root.querySelectorAll('[data-dot]')];
      this.pauseButton = root.querySelector('[data-pause]');
      this.count = this.slides.length;
      this.index = 0;
      this.turn = 0;
      this.radius = 0;
      this.userPaused = false;
      this.hold = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = root.dataset.autoplay === 'true' && !this.reduced && this.count > 1;
      this.interval = Number(root.dataset.interval) || 6000;
      if (this.count < 2) {
        root.classList.add('is-single');
        return;
      }
      root.classList.add('is-3d');
      this.bind();
      this.layout();
      new ResizeObserver(() => this.layout()).observe(this.ring);
      if (this.autoplay) this.timer = setInterval(() => this.tick(), this.interval);
      else if (this.pauseButton) this.pauseButton.hidden = true;
    }

    get angle() {
      return 360 / this.count;
    }

    layout() {
      const width = this.ring.offsetWidth;
      if (!width) return;
      const ideal = this.count > 2 ? width / 2 / Math.tan(Math.PI / this.count) : width * 0.35;
      this.radius = Math.max(ideal * 1.12 + 24, width * 0.6);
      this.slides.forEach((slide, i) => {
        slide.style.transform = `rotateY(${i * this.angle}deg) translateZ(${this.radius}px)`;
      });
      this.apply();
    }

    apply() {
      this.ring.style.transform = `translateZ(${-this.radius}px) rotateY(${-this.turn * this.angle}deg)`;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    go(target) {
      const n = this.count;
      let delta = (((target - this.index) % n) + n) % n;
      if (delta > n / 2) delta -= n;
      this.turn += delta;
      this.index = ((target % n) + n) % n;
      this.apply();
    }

    next() {
      this.go(this.index + 1);
    }

    prev() {
      this.go(this.index - 1);
    }

    tick() {
      if (this.userPaused || this.hold || document.hidden) return;
      this.next();
    }

    setPaused(paused) {
      this.userPaused = paused;
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-pressed', String(paused));
      const label = this.pauseButton.querySelector('[data-pause-label]');
      label.textContent = paused ? label.dataset.labelPlay : label.dataset.labelPause;
    }

    bind() {
      this.root.querySelector('[data-next]')?.addEventListener('click', () => this.next());
      this.root.querySelector('[data-prev]')?.addEventListener('click', () => this.prev());
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
      this.pauseButton?.addEventListener('click', () => this.setPaused(!this.userPaused));

      this.root.addEventListener('mouseenter', () => (this.hold = true));
      this.root.addEventListener('mouseleave', () => (this.hold = false));
      this.root.addEventListener('focusin', () => (this.hold = true));
      this.root.addEventListener('focusout', (event) => {
        if (!this.root.contains(event.relatedTarget)) this.hold = false;
      });

      this.root.addEventListener('keydown', (event) => {
        if (event.target.closest('input, textarea, select')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.prev();
        }
      });

      this.slides.forEach((slide, i) => {
        slide.addEventListener('click', (event) => {
          if (this.dragged) {
            event.preventDefault();
            return;
          }
          if (i !== this.index) {
            event.preventDefault();
            this.go(i);
          }
        });
      });

      const stage = this.root.querySelector('.carousel3d__stage');
      let startX = null;
      stage.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        this.dragged = false;
      });
      stage.addEventListener('pointermove', (event) => {
        if (startX !== null && Math.abs(event.clientX - startX) > 10) this.dragged = true;
      });
      const end = (event) => {
        if (startX === null) return;
        const dx = event.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) dx < 0 ? this.next() : this.prev();
        setTimeout(() => (this.dragged = false), 0);
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', () => (startX = null));
      stage.addEventListener('dragstart', (event) => event.preventDefault());

      document.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.findIndex((s) => s.contains(event.target));
        if (i >= 0) {
          this.hold = true;
          this.go(i);
        }
      });
      document.addEventListener('shopify:block:deselect', () => (this.hold = false));
    }
  }

  const initCarousels = (scope = document) =>
    scope.querySelectorAll('[data-carousel3d]').forEach((root) => {
      if (!root._carousel) root._carousel = new Carousel3D(root);
    });
  initCarousels();
  document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));

  /* Sliders */
  function initSliders(scope = document) {
    scope.querySelectorAll('[data-slider-track]').forEach((track) => {
      if (track._slider) return;
      track._slider = true;
      const prev = document.querySelector(`[data-slider-prev][aria-controls="${track.id}"]`);
      const next = document.querySelector(`[data-slider-next][aria-controls="${track.id}"]`);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        const buttons = prev?.parentElement;
        if (buttons) buttons.hidden = track.scrollWidth <= track.clientWidth + 2;
      };
      const step = (dir) => {
        const slide = track.querySelector(':scope > *');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const slideWidth = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
        const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / slideWidth));
        track.scrollBy({ left: dir * slideWidth * perPage, behavior: 'smooth' });
      };
      prev?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  }

  /* Click-to-play videos and maps */
  document.addEventListener('click', (event) => {
    const poster = event.target.closest('[data-video-play]');
    if (poster) {
      const { videoType, videoId, videoTitle } = poster.dataset;
      const src =
        videoType === 'vimeo'
          ? `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&dnt=1`
          : `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&playsinline=1`;
      const frame = document.createElement('iframe');
      frame.src = src;
      frame.title = videoTitle || '';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.className = 'video__frame';
      poster.replaceWith(frame);
      frame.focus();
      return;
    }
    const mapButton = event.target.closest('[data-map-load]');
    if (mapButton) {
      const frame = document.createElement('iframe');
      frame.src = mapButton.dataset.src;
      frame.title = mapButton.dataset.title || '';
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      mapButton.replaceWith(frame);
    }
  });

  /* Countdowns */
  function initCountdowns(scope = document) {
    scope.querySelectorAll('[data-countdown]').forEach((clock) => {
      if (clock._timer) clearInterval(clock._timer);
      const target = Date.parse(clock.dataset.countdown);
      const units = clock.querySelector('.countdown__units');
      const done = clock.querySelector('[data-countdown-done]');
      if (Number.isNaN(target)) {
        units.hidden = true;
        return;
      }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        if (diff === 0) {
          units.hidden = true;
          if (done) done.hidden = false;
          clearInterval(clock._timer);
          return;
        }
        const days = Math.floor(diff / 86400000);
        diff -= days * 86400000;
        const hours = Math.floor(diff / 3600000);
        diff -= hours * 3600000;
        const minutes = Math.floor(diff / 60000);
        const seconds = Math.floor((diff - minutes * 60000) / 1000);
        clock.querySelector('[data-unit="days"]').textContent = pad(days);
        clock.querySelector('[data-unit="hours"]').textContent = pad(hours);
        clock.querySelector('[data-unit="minutes"]').textContent = pad(minutes);
        clock.querySelector('[data-unit="seconds"]').textContent = pad(seconds);
      };
      tick();
      clock._timer = setInterval(tick, 1000);
    });
  }

  /* Decklist search */
  function initDecklists(scope = document) {
    scope.querySelectorAll('[data-decklist]').forEach((root) => {
      if (root._decklist) return;
      root._decklist = true;
      const section = root.closest('.shopify-section') || document;
      let strings = {};
      try {
        strings = JSON.parse(section.querySelector('[data-decklist-strings]')?.textContent || '{}');
      } catch (e) {}
      const t = (key, vars = {}) =>
        (strings[key] || key).replace(/\{\{\s*(\w+)\s*\}\}|\[(\w+)\]/g, (_, a, b) => vars[a || b] ?? '');
      const form = root.querySelector('[data-decklist-form]');
      const input = root.querySelector('[data-decklist-input]');
      const submit = root.querySelector('[data-decklist-submit]');
      const results = root.querySelector('[data-decklist-results]');
      const rowsEl = root.querySelector('[data-decklist-rows]');
      const summary = root.querySelector('[data-decklist-summary]');
      const totalEl = root.querySelector('[data-decklist-total]');
      const addButton = root.querySelector('[data-decklist-add]');
      const errorEl = root.querySelector('[data-decklist-error]');
      const maxLines = Number(root.dataset.maxLines) || 80;
      const productCache = new Map();
      let rows = [];

      const esc = (s) =>
        String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

      const parse = (text) => {
        const map = new Map();
        text.split(/\r?\n/).forEach((raw) => {
          let line = raw.trim();
          if (!line || /^(\/\/|#)/.test(line) || /^(deck|sideboard|commander|companion|maybeboard)\s*:?$/i.test(line)) return;
          const m = line.match(/^(\d+)\s*x?\s+(.+)$/i);
          let qty = 1;
          if (m) {
            qty = Number(m[1]);
            line = m[2];
          }
          line = line
            .replace(/\s+\([A-Z0-9]{2,6}\)\s*[\w-]*\s*$/i, '')
            .replace(/\s+\*[A-Z]+\*\s*$/i, '')
            .replace(/\s+#\S+$/, '')
            .trim();
          if (!line) return;
          const key = line.toLowerCase();
          const existing = map.get(key);
          if (existing) existing.qty += qty;
          else map.set(key, { name: line, qty });
        });
        return [...map.values()];
      };

      const normalise = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

      const findProduct = async (name) => {
        const url = `${B.routes.predictive_search_url}.json?q=${encodeURIComponent(name)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return null;
        const json = await res.json();
        const list = json.resources?.results?.products || [];
        const target = normalise(name);
        const scored = list
          .map((p) => {
            const title = normalise(p.title);
            let score = 0;
            if (title === target) score = 4;
            else if (title.startsWith(target + ' ')) score = 3;
            else if (title.includes(target)) score = 2;
            return { p, score };
          })
          .filter((x) => x.score > 0)
          .sort((a, b) => b.score - a.score);
        const candidates = scored.map((x) => x.p);
        for (const candidate of candidates) {
          const handle = candidate.handle || new URL(candidate.url, location.origin).pathname.split('/products/')[1]?.split(/[/?]/)[0];
          if (!handle) continue;
          let product = productCache.get(handle);
          if (!product) {
            const pres = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
            if (!pres.ok) continue;
            product = await pres.json();
            productCache.set(handle, product);
          }
          if (product.variants.some((v) => v.available)) return product;
        }
        if (candidates[0]) {
          return { title: candidates[0].title, url: candidates[0].url, variants: [], soldOut: true };
        }
        return null;
      };

      const render = () => {
        rowsEl.innerHTML = rows
          .map((row, i) => {
            if (row.status === 'pending') {
              return `<tr class="is-pending"><td></td><td>${row.qty}</td><td>${esc(row.name)}</td><td class="muted" colspan="2">${esc(t('searching'))}</td></tr>`;
            }
            if (row.status === 'missing' || row.status === 'soldout') {
              const label = row.status === 'soldout' ? t('soldOut') : t('notFound');
              return `<tr class="is-missing"><td></td><td>${row.qty}</td><td>${esc(row.name)}</td><td><span class="decklist__status decklist__status--missing">${esc(label)}</span>${row.product ? ` <a href="${esc(row.product.url)}">${esc(row.product.title)}</a>` : ''}</td><td></td></tr>`;
            }
            const options = row.variants
              .map((v) => `<option value="${v.id}" ${v.id === row.variantId ? 'selected' : ''}>${esc(v.title === 'Default Title' ? row.product.title : v.title)} – ${esc(formatMoney(v.price))}</option>`)
              .join('');
            const variant = row.variants.find((v) => v.id === row.variantId);
            return `<tr>
              <td><input type="checkbox" data-row-check="${i}" ${row.selected ? 'checked' : ''} aria-label="${esc(row.name)}"></td>
              <td><input class="decklist__qty" type="number" min="1" value="${row.qty}" data-row-qty="${i}" aria-label="${esc(row.name)}"></td>
              <td><a href="${esc(row.product.url)}">${esc(row.product.title)}</a></td>
              <td>${row.variants.length > 1 ? `<select data-row-variant="${i}" aria-label="${esc(row.name)}">${options}</select>` : `<span class="decklist__status">${esc(t('inStock'))}</span>`}</td>
              <td class="num">${variant ? esc(formatMoney(variant.price * row.qty)) : ''}</td>
            </tr>`;
          })
          .join('');
        const found = rows.filter((r) => r.status === 'found');
        const selected = found.filter((r) => r.selected);
        const total = selected.reduce((sum, r) => {
          const v = r.variants.find((x) => x.id === r.variantId);
          return sum + (v ? v.price * r.qty : 0);
        }, 0);
        totalEl.textContent = formatMoney(total);
        addButton.disabled = selected.length === 0;
        const done = rows.every((r) => r.status !== 'pending');
        summary.textContent = done ? t('found', { found: found.length, total: rows.length }) : t('searching');
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        errorEl.hidden = true;
        let cards = parse(input.value);
        if (!cards.length) {
          errorEl.textContent = t('empty');
          errorEl.hidden = false;
          results.hidden = false;
          return;
        }
        if (cards.length > maxLines) {
          errorEl.textContent = t('tooMany');
          errorEl.hidden = false;
          cards = cards.slice(0, maxLines);
        }
        rows = cards.map((c) => ({ ...c, status: 'pending', selected: true }));
        results.hidden = false;
        submit.disabled = true;
        render();
        let next = 0;
        const worker = async () => {
          while (next < rows.length) {
            const row = rows[next++];
            try {
              const product = await findProduct(row.name);
              if (!product) {
                row.status = 'missing';
              } else if (product.soldOut) {
                row.status = 'soldout';
                row.product = product;
              } else {
                row.product = product;
                row.variants = product.variants.filter((v) => v.available).sort((a, b) => a.price - b.price);
                row.variantId = row.variants[0].id;
                row.status = 'found';
              }
            } catch (e) {
              row.status = 'missing';
            }
            render();
          }
        };
        await Promise.all([worker(), worker(), worker(), worker()]);
        submit.disabled = false;
        render();
      });

      rowsEl.addEventListener('change', (event) => {
        const el = event.target;
        if (el.dataset.rowCheck) rows[el.dataset.rowCheck].selected = el.checked;
        if (el.dataset.rowQty) rows[el.dataset.rowQty].qty = Math.max(1, Number(el.value) || 1);
        if (el.dataset.rowVariant) rows[el.dataset.rowVariant].variantId = Number(el.value);
        render();
      });

      addButton.addEventListener('click', async () => {
        const items = rows
          .filter((r) => r.status === 'found' && r.selected)
          .map((r) => ({ id: r.variantId, quantity: r.qty }));
        if (!items.length) return;
        addButton.disabled = true;
        errorEl.hidden = true;
        try {
          const res = await fetch(B.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const body = await res.json();
          if (!res.ok) throw new Error(body.description || body.message || B.strings.addError);
          await refreshCartCount();
          showToast(t('added', { count: items.length }));
        } catch (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } finally {
          addButton.disabled = false;
        }
      });
    });
  }

  const initSections = (scope = document) => {
    initSliders(scope);
    initCountdowns(scope);
    initDecklists(scope);
  };
  initSections();
  document.addEventListener('shopify:section:load', (event) => initSections(event.target));
})();
